import ConsumerInfoForm from "./consumerInfoForm";
import ConsumerInfoSection from "./consumerInfoSection";
import ConsumerComplainsList from "./consumerComplainsList";

export {
    ConsumerInfoForm,
    ConsumerInfoSection,
    ConsumerComplainsList,
}